<template>
	<div
		class="relative flex h-9 w-9 items-center justify-center"
		v-hover="{ active: 'scale-95' }"
	>
		<LazyImage
			:src="avatarSm(avatar)"
			alt="avatar"
			class="h-8 w-8 rounded-full"
		/>
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="absolute inset-0"
		>
			<circle
				:class="{ 'text-red': isActive, 'text-fill-secondary': !isActive }"
				cx="18"
				cy="18"
				r="17"
				stroke="currentColor"
				stroke-width="2"
			/>
			<circle
				class="text-black"
				cx="18"
				cy="18"
				r="15"
				stroke="currentColor"
				stroke-width="2"
				v-if="!isActive"
			/>
			<circle
				cx="18"
				cy="18"
				r="17"
				stroke="#C4C4C4"
				stroke-width="2"
				:stroke-dasharray="dasharray"
				:stroke-dashoffset="dashoffset"
				stroke-linecap="round"
				class="origin-center -rotate-90"
				:class="{
					'translate-all duration-500': firstUpdate
				}"
				v-if="!isActive"
			/>
		</svg>
		<LevelPill
			class="absolute -top-px right-full translate-x-1/2"
			:class="{
				'animate-blink': blink
			}"
			v-if="!isActive"
		>
			{{ level }}
		</LevelPill>
	</div>
</template>
<script setup lang="ts">
import { computed, ref, watch, nextTick } from 'vue'
import LazyImage from './LazyImage.vue'
import { sleep } from '@/utils/sleep'
import { avatarSm } from '@/utils/urls'
import LevelPill from './LevelPill.vue'

const props = withDefaults(
	defineProps<{
		avatar: string
		level: number
		levelPercent: number
		isActive?: boolean
	}>(),
	{
		level: 0,
		levelPercent: 0
	}
)

const dashoffset = computed(() => {
	const radius = 17
	const circumference = 2 * Math.PI * radius

	return circumference - (props.levelPercent / 100) * circumference
})

const firstUpdate = ref(false)
const blink = ref(false)

watch(
	() => props.level,
	async () => {
		if (!firstUpdate.value) {
			await nextTick()
			await sleep(10)
			firstUpdate.value = true
			return
		}

		blink.value = true
		await sleep(550)
		blink.value = false
	}
)

const dasharray = computed(() => {
	const radius = 17

	return 2 * Math.PI * radius
})
</script>
